/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import MentionHeading from './MentionHeading'
import styles, { listPosition } from './styles'

const MentionMenu = ({ position, label, theme, selectedHandle, children, ...props }) => (
  <dl className={cx(styles.list, listPosition(position))}>
    {Boolean(position === 'bottom') && <MentionHeading label={label} />}

    <dl className={styles.body} ref={props.menuRef} onMouseOver={props.onHover}>
      {React.Children.map(children, child => {
        const childHandle = child.props.handle
        const selected = selectedHandle === childHandle
        return React.cloneElement(child, {
          theme,
          selected,
          onHover: () => props.onOptionHover(childHandle),
          onSelect: () => props.onOptionSelect(childHandle),
        })
      })}
    </dl>

    {Boolean(position === 'top') && <MentionHeading label={label} />}
  </dl>
)

MentionMenu.propTypes = {
  label: PropTypes.string,
  position: PropTypes.oneOf(['', 'bottom', 'top']),
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  selectedHandle: PropTypes.string,
  onHover: PropTypes.func,
  onOptionHover: PropTypes.func,
  onOptionSelect: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  menuRef: PropTypes.func,
}

MentionMenu.defaultProps = {
  label: 'Teammates matching @',
  position: 'bottom',
  theme: 'primary',
}

export default MentionMenu
